import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import DashboardHeader from "../../components/DashboardHeader/DashboardHeader";
import DashboardMainPage from "../../components/DashboardMainPage/Dashboard_mainPage";
import ScheduleConsultPage from "../../components/ScheduleConsult/ScheduleConsultPage";
import BookAppointment from "../../components/ScheduleConsult/BookAppointment";
import ApptBooked from "../../components/ApptBooked/Appointment";
import Details from "../../components/Details/Details";
import { useLocation } from "react-router-dom"; 
import "./Dashboard.css";

const Dashboard: React.FC = () => {
  const location = useLocation(); 
  return (
    <div className="app-container">
      <Header />
      <DashboardHeader />
      <div className="dashboard-content">
        {location.pathname === "/dashboard" && <DashboardMainPage />}
        {location.pathname === "/dashboard/account" && <Details />}
        {location.pathname === "/dashboard/schedule_consultation" && (
          <ScheduleConsultPage />
        )}
        {location.pathname === "/dashboard/book_appointment" && (
          <BookAppointment />
        )}
        {location.pathname === "/dashboard/appointment_booked" && (
          <ApptBooked />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;
